<template>
  <div class="py-1 px-2 col-span-2 text-center flex flex-col justify-center items-center border-r border-gray-200 dark:border-gray-700">
    <div class="flex items-center justify-center">
      <i :class="`pi ${status === 'open' ? 'pi-clock text-blue-500' : 'pi-check-circle text-green-500'} mr-1`"></i>
      <span :class="{'text-blue-600': status === 'open', 'text-green-600': status === 'closed'}" class="text-xs">
        {{ status === 'open' ? 'Open' : 'Closed' }}
      </span>
    </div>
    <div v-if="date" class="text-xs text-gray-500 mt-1">
      {{ formattedDate }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  status: string;
  date?: string | Date;
}>();

const formattedDate = computed(() => {
  if (!props.date) return '';

  const date = props.date instanceof Date ? props.date : new Date(props.date);
  return getDateDutchFormat(date);
});

function getDateDutchFormat(date: Date): string {
  return date.toLocaleDateString('nl-NL', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
}
</script>
